"use strict";
/**
 * AUTO-GENERATED FILE.
 *
 * Generated from Shopify countries/provinces JSON via scripts/generateCountryTaxRates.ts
 * Do not edit manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.COUNTRY_TAX_RATES = void 0;
exports.COUNTRY_TAX_RATES = {
    "CY": 0.19,
    "EG": 0.01,
    "PL": 0.23,
    "PT": 0.23,
    "GB": 0.2
};
